import { Component, DestroyRef, OnInit, input, ViewChild, inject } from '@angular/core';
import { CustomerAutoCompleteService } from './customer-autocomplete.service';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, finalize } from 'rxjs/operators';
import { Customer } from '@app/core/stingray-api/models';
import { requireMatch } from '@app/validators/autocomplete-validator';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatInput } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';

@Component({
    selector: 'unite-customer-autocomplete',
    templateUrl: './customer-autocomplete.component.html',
    styleUrls: ['./customer-autocomplete.component.scss'],
    imports: [MatFormField, MatLabel, MatIconButton, MatSuffix, MatIcon, NgClass, MatProgressSpinner, MatInput, ReactiveFormsModule, MatAutocompleteTrigger, MatAutocomplete, MatOption, TranslateModule]
})
export class CustomerAutocompleteComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  @ViewChild('customerSearchInput') customerSearchInput: MatInput;

  control = input<FormControl>();
  required = input(false);
  focus = input(false);
  label = input<string>();
  type = input<'All' | 'Person' | 'Company' | 'Collaboration'>();

  customers: Customer[] = [];

  isLoadingCustomers = false;

  constructor(
    private customerAutoCompleteService: CustomerAutoCompleteService) { }

  ngOnInit() {
    if (this.required() === false) {
      this.control().setValidators([requireMatch]);
    } else {
      this.control().setValidators([Validators.required, requireMatch]);
    }

    this.control().valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
      debounceTime(750)
    ).subscribe(() => {
      this.searchCustomers()
    });
  }

  searchCustomers() {
    var name = this.control().value;

    if(name == null || name.length < 3) {
      return;
    }

    this.isLoadingCustomers = true;
    this.customerAutoCompleteService.getCustomers(true, name).pipe(
      finalize(() => {
        this.isLoadingCustomers = false;
      })
    ).subscribe((customers: Customer[]) => {
      if (this.type() !== 'All') {
        customers = customers.filter(customer => customer.type === this.type());
      }

      this.customers = customers;
    });
  }

  refreshCustomers() {
    this.searchCustomers();
  }

  displayWithCustomer(customer: Customer): string {
    if (customer != null) {
      return customer.name;
    } else {
      return '';
    }
  }

  isCustomer(value: any | Customer): value is Customer {
    return value != null && (<Customer>value).id !== undefined;
  }
}
